"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * @author PKr
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of DistributionModel
 * @author RV
 */


var SupplierAgreementUpdateDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierAgreementUpdateDTOConverter, _DataObjectConverter_);

  function SupplierAgreementUpdateDTOConverter() {
    _classCallCheck(this, SupplierAgreementUpdateDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementUpdateDTOConverter).apply(this, arguments));
  }

  return SupplierAgreementUpdateDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierAgreementUpdateDTOConverter = SupplierAgreementUpdateDTOConverter;